import React from 'react'
import DialogModal from 'shared/components/DialogModal'
import PropTypes from 'prop-types'
import Bullet from 'shared/components/Bullet'
import { Typography, Grid, Stack } from '@mui/material'
import { ButtonContained } from 'shared/components/Button'

const PetunjukDialog = ({ open, handleClose, action }) => {
    return (
        <DialogModal open={open} handleClose={handleClose} size='sm' title={action === 'tambah' ? 'Petunjuk Tambah Dokumen' : 'Petunjuk Ubah Dokumen'}>
            <Grid container spacing={3}>
                <Item title='Judul SK' value='Isi judul SK yang akan dibagikan' />
                <Item title='No SK' value='Isi nomer SK yang akan dibagikan' />
                <Item title='Penandatangan' value='Pilih penandatangan yang akan dibagikan terkait SK dengan klik label penerima surat atau text field' />
                <Item title='Kategori SK' value='Pilih Kategori SK yang akan dibagikan' />
                <Item title='Jenis SK' value='Pilih jenis SK yang akan dibagikan' />
                <Item title='Penerima' value='Pilih Penerima yang akan dibagikan terkait SK dengan klik label penerima surat atau text field' />
                <Item title='Tembusan' value='Pilih Tembusan yang akan dibagikan terkait SK dengan klik label penerima surat atau text field' />

                <Item title='Lampiran' value='Tambahkan SK yang akan dibagikan dengan tarik SK ke dalam kotak lampiran atau dengan klik icon unggah' />
                <Item title='Keterangan' value='Beri catatan terkait SK yang akan dibagikan' />
            </Grid>

            <Stack justifyContent='flex-end' alignItem='flex-end' marginTop={3} flexDirection='row'>
                <ButtonContained variant='contained' onClick={handleClose}>Tutup</ButtonContained>
            </Stack>
        </DialogModal>
    )
}

const Item = ({ title, value }) => {
    return (
        <>
            <Grid item container spacing={2}>
                <Grid item xs={12} md={4}>
                    <Stack direction='row' alignItems={'center'} spacing={2}>
                        <Bullet />
                        <Typography variant='h5' fontWeight='500'>{title}</Typography>
                    </Stack>
                </Grid>
                <Grid item xs={12} md={8}>
                    <Typography>{value}</Typography>
                </Grid>
            </Grid>
        </>
    )
}

Item.propTypes = {
    title: PropTypes.string,
    value: PropTypes.string
}

PetunjukDialog.propTypes = {
    open: PropTypes.bool,
    action: PropTypes.string,
    handleClose: PropTypes.func,
}

export default PetunjukDialog
